module.exports = __webpack_public_path__ + "static/media/background.3b89e7be.png";